<template>
  <div class="basic-contacts">
    <div class="basic-contacts-wrapper">
      <h3>{{ heading }}</h3>
      <address>
        <span>{{ address }}</span>
        <span>( <router-link to="/contacts">см. на карте</router-link> )</span>
      </address>
      <p>
        <span>Позвоните нам:</span>
        <span><a v-bind:href="phoneHref">{{ phone }}</a></span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicContacts',
  props: {
    heading: {
      type: String,
      default: 'Aдрес нашего магазина:'
    }
  },
  data: function () {
    return {
      address: 'Брест, ул. Сябровская 51 «А»',
      phone: '+375 29 8888-099'
    }
  },
  computed: {
    phoneHref: function () {
      return 'tel:' + this.phone.replace(/ /g, '-')
    }
  }
}
</script>

<style scoped lang="scss">
  .basic-contacts  {
    @include centered-block-width($big-tablet: 80%, $small-tablet: 90%);
    color: $default-heading-color;
    font-family: "Gotham Pro Regular", $font-stack;
    text-align: center;
    & > .basic-contacts-wrapper {
      display: inline-block;
      padding: 1em;
      border-top: 1px solid $default-link-color;
      border-bottom: 1px solid $default-link-color;
      & > * {
        margin-bottom: 0.25em;
        &:last-child { margin-bottom: 0; }
        & > span { display: inline-block; }
      }
      & > h3 {
        font-size: 1em;
        font-weight: bold;
        line-height: 1.625;
      }
      & > address {
        font-style: normal;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/utils/BasicContacts.vue